<template>
  <div class="tournament-single">
    <div class="container">
      <TournamentHeader :tournament="tournament"></TournamentHeader>
      <div class="tournament-content">
        <h1>Partidas</h1>

        <b-button
          v-if="isTournamentAdmin && isAvailable"
          variant="primary"
          v-b-modal.modalCreateMatch
        >Criar partida</b-button>
        <b-modal
          @ok="handleCreateMatchOk"
          id="modalCreateMatch"
          title="Criar partida"
          ref="modalCreateMatch"
          v-if="isTournamentAdmin"
        >
          <form @submit.stop.prevent="handleCreateMatchSubmit">
            <b-form-group description label="Time A">
              <b-form-select v-model="team_a_id" class="mb-3">
                <option
                  v-for="team in tournament.tournament_teams"
                  :key="team.id"
                  :value="team.team.id"
                >{{team.team.name}}</option>
              </b-form-select>
            </b-form-group>

            <b-form-group description label="Time B">
              <b-form-select v-model="team_b_id" class="mb-3">
                <option
                  v-for="team in tournament.tournament_teams"
                  :key="team.id"
                  :value="team.team.id"
                >{{team.team.name}}</option>
              </b-form-select>
            </b-form-group>

            <b-form-group description label="Data e Horário">
              <datetime
                required
                v-model="start_time"
                type="datetime"
                :min-datetime="minScheduleDate"
                :max-datetime="maxScheduleDate"
                :minute-step="10"
                input-class="form-control"
                class="mb-3"
              ></datetime>
            </b-form-group>

            <b-form-checkbox
              v-model="skip_veto"
              :value="true"
              :unchecked-value="false"
            >
              Quero escolher o mapa e pular o veto no servidor
            </b-form-checkbox>

            <b-form-group label="Mapa" v-if="skip_veto">
              <b-form-radio-group
                v-model="map"
                :options="mapOptions"
                name="radios-stacked"
                stacked
                required
              ></b-form-radio-group>
            </b-form-group>
          </form>
        </b-modal>

        <div class="stats-table" v-if="tournament.matches.length > 0">
          <table class="table is-hoverable">
            <thead>
              <tr>
                <th>Partida</th>
                <th>
                  <abbr title="Data">Data</abbr>
                </th>
                <th class="team-header">
                  <abbr title="Time 1">Time 1</abbr>
                </th>
                <th class="versus-header">
                  <abbr title>x</abbr>
                </th>
                <th class="team-header">
                  <abbr title="Time 2">Time 2</abbr>
                </th>
                <th>
                  <abbr title="Mapa">Mapa</abbr>
                </th>
                <th class="team-header">
                  <abbr title="Lobby"></abbr>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="match in tournament.matches" :key="match.id">
                <td>#{{ match.match_code }}</td>
                <td>{{ match.start_time_friendly }}</td>

                <td
                  :class="`team-column ${match.winner && (match.winner == 'team1' && match.team1_score >= 16) ? 'winner' : ''}`"
                >
                  <span class="team-score">{{ match.team1_score }}</span>
                  <router-link
                    :to="{ name: 'TeamSingle', params: { id: match.team_a.to_param }}"
                    v-if="match.team_a"
                  >{{ match.team_a.name }}</router-link>
                </td>
                <td class="versus-column">
                  <!-- <span>live</span> -->
                  <!-- v-if="lobby.status == 'match-ready'" -->
                  x
                </td>
                <td
                  :class="`team-column ${match.winner && (match.winner == 'team2' && match.team2_score >= 16) ? 'winner' : ''}`"
                >
                  <span class="team-score">{{ match.team2_score }}</span>
                  <router-link
                    :to="{ name: 'TeamSingle', params: { id: match.team_b.to_param }}"
                    v-if="match.team_b"
                  >{{ match.team_b.name }}</router-link>
                </td>

                <td>{{ match.map }}</td>
                <td>
                  <router-link :to="{ name: 'LobbySingle', params: { id: match.id }}">ver partida</router-link>

                  <b-badge
                    v-if="match.team1_score < 16 && match.team2_score < 16 && isTournamentAdmin"
                    @click="deleteMatch(match.id)"
                    variant="danger"
                  >apagar</b-badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="tournament.matches.length == 0" class="no-results">
          <h4>partidas ainda não disponíveis</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  .tournament-content
    background: #efefef
    border-left: 1px solid #fff
    border-right: 1px solid #fff
    border-bottom: 1px solid #fff
    padding: 20px
  .stats-table
    table
      td
        padding: 0.25em 0.45em
        font-size: 14px
        &:last-of-type
          text-align: center
          a
            display: block
            font-size: 13px
            &:hover
              text-decoration: underline
              font-weight: bold
    a
      color: #008EB4

    .versus-header
      text-align: center
    .versus-column
      text-align: center
      span
        display: block
        font-size: 12px
        background: green
        color: white
        padding: 3px 5px
        border-radius: 4px
    .team-header
      text-align: center
    .team-column
      text-align: center
      &.winner
        color: green
        font-weight: bold
    .team-score
      text-align: center
      display: block
    .lobby-size
      display: block

</style>

<script>
import TournamentHeader from "@/components/TournamentHeader";
// import TeamCard from '@/components/TeamCard'
import { DateTime } from "luxon";
export default {
  name: "TournamentMatches",
  data() {
    return {
      tournament: {
        featured_image: "",
        title: "",
        id: 0,
        cover: {},
        badge: {},
        matches: []
      },
      team_id: 0,
      matches: [],
      team_a_id: 0,
      team_b_id: 0,
      teams: [],
      skip_veto: false,
      map: 'de_mirage',
      mapOptions: [
        { text: 'de_mirage', value: 'de_mirage' },
        { text: 'de_inferno', value: 'de_inferno' },
        { text: 'de_dust2', value: 'de_dust2' },
        { text: 'de_vertigo', value: 'de_vertigo' },
        { text: 'de_overpass', value: 'de_overpass' },
        { text: 'de_train', value: 'de_train' },
        { text: 'de_nuke', value: 'de_nuke' }
      ],
      startTime: {},
      start_time: ""
    };
  },
  metaInfo() {
    return {
      title: `${this.tournament.name}`
    };
  },
  computed: {
    isTournamentAdmin: function() {
      return (
        this.$store.getters.isLoggedIn &&
        this.tournament &&
        this.tournament.tournament_staff &&
        this.tournament.tournament_staff
          .map(i => i.user.id)
          .includes(this.$store.getters.user.id)
      );
    },
    isAvailable: function() {
      return this.tournament.is_payed
    },
    minScheduleDate: function() {
      // var now = new Date()
      // now.setMinutes(now.getMinutes() + 10)
      // return now.toISOString()
      return DateTime.local()
        .setZone("America/Sao_Paulo")
        .plus({ minutes: 10 })
        .toISODate();
    },
    maxScheduleDate: function() {
      return DateTime.local()
        .setZone("America/Sao_Paulo")
        .plus({ hours: 64 })
        .toISODate();
    }
  },
  methods: {
    initialize() {
      this.$http
        .get(`tournaments/${this.$route.params.id}.json`)
        .then(response => {
          this.tournament = response.data;
        });
    },

    handleCreateMatchSubmit() {
      this.handleCreateMatchOk();
    },
    handleCreateMatchOk() {
      this.$http
        .post(`tournaments/${this.$route.params.id}/create_match.json`, {
          team_a_id: this.team_a_id,
          team_b_id: this.team_b_id,
          start_time: this.start_time,
          skip_veto: this.skip_veto,
          map: this.map
        })
        .then(response => {
          this.$notify({
            group: "all",
            title: "Partida gerada - irá aparecer para os usuários na home"
          });
          this.initialize();
          this.$refs.modalCreateMatch.hide();
          this.team_a_id = 0;
          this.team_b_id = 0;
          this.start_time = '';
          this.skip_veto = false;
          this.map = 'de_mirage';
        })
        .catch(error => {
          this.$refs.modalCreateMatch.hide();
        });
    },
    deleteMatch(lobby_id) {
      if (confirm("Você tem certeza? Essa ação não tem retorno!"))
        this.$http
          .get(
            `tournaments/${
              this.$route.params.id
            }/delete_match.json?lobby_id=${lobby_id}`
          )
          .then(response => {
            this.$notify({
              group: "all",
              title: "Partida apagada"
            });
            this.initialize();
          })
          .catch(error => {
            alert("Partida não encontrada");
          });
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  },
  components: {
    TournamentHeader
  }
};
</script>
